interface AppVersionConfig {
    version: string
    versionCode: number
    buildNumber?: string
}

interface AppVersions {
    android: AppVersionConfig
    ios: AppVersionConfig
    isIos: boolean
    web: AppVersionConfig
}

// Marketing version (semantic X.Y.Z) y códigos incrementales internos
// appVersion -> CFBundleShortVersionString (iOS) / version (Android)
// versionCode -> android versionCode (int) / CFBundleVersion (iOS build number)
const appVersion = '2.8.42'
const versionCode = 688 // Incrementar SOLO cuando publiques un nuevo build

// Detecta plataforma durante EAS Build; fallback a variable de entorno manual o iOS local
export const isIos = process.env.EAS_BUILD_PLATFORM === 'ios' || process.env.PLATFORM === 'ios'

export const android: AppVersionConfig = {
    version: appVersion,
    versionCode,
}

export const ios: AppVersionConfig = {
    // Corregido: antes se usaba versionCode como CFBundleShortVersionString causando warning
    version: appVersion, // CFBundleShortVersionString (debe ser X.Y.Z)
    versionCode, // No usado directamente pero mantenemos simetría
    buildNumber: versionCode.toString(), // CFBundleVersion (entero incremental)
}
export const web: AppVersionConfig = {
    version: appVersion,
    versionCode,
}
const versions: AppVersions = {
    android,
    ios,
    isIos,
    web,
}

export default versions

// const isIOS = process.env.EAS_BUILD_PLATFORM === 'ios'
// const isAndroid = process.env.EAS_BUILD_PLATFORM === 'android'
//
